export default "<div (window:resize)=\"onResize($event)\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n"